import { TranslationKey } from '@lang';

type GenderOption = {
  label: string;
  id: TranslationKey;
  value: 'male' | 'female' | 'neutral';
};

export const genderOptions: GenderOption[] = [
  { label: 'Male', value: 'male', id: 'common.male' },
  { label: 'Female', value: 'female', id: 'common.female' },
];

export const genderOptionsWithNeutral: GenderOption[] = [
  ...genderOptions,
  { label: 'Prefer not to say', value: 'neutral', id: 'common.genderNeutral' },
];
